export enum Frequency {
  Weekly = 'Weekly',
  EOW = 'Every other week',
  Monthly = 'Monthly',
  TwoPerWeek = '2 times a week',
  ThreePerWeek = '3 times a week',
  FourPerWeek = '4 times a week',
  FivePerWeek = '5 times a week',
  SixPerWeek = '6 times a week',
}

export const FrequencyMapping = {
  [Frequency.Weekly]: 1,
  [Frequency.EOW]: 1,
  [Frequency.Monthly]: 1,
  [Frequency.TwoPerWeek]: 2,
  [Frequency.ThreePerWeek]: 3,
  [Frequency.FourPerWeek]: 4,
  [Frequency.FivePerWeek]: 5,
  [Frequency.SixPerWeek]: 6,
} as const;
